module.exports = __webpack_public_path__ + "img/marketplace.87c2163d.svg";